import { render, staticRenderFns } from "./saved-filters.vue?vue&type=template&id=9a88c032&scoped=true&"
import script from "./saved-filters.vue?vue&type=script&lang=js&"
export * from "./saved-filters.vue?vue&type=script&lang=js&"
import style0 from "./saved-filters.vue?vue&type=style&index=0&id=9a88c032&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a88c032",
  null
  
)

export default component.exports